import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
const InputSearch = (props) => {
  const { name, label, value, type, error = null, onChange, ...other } = props;

  return (
    <TextField
      sx={{ width: "320px", margin: "10px 0" }}
      variant="outlined"
      name={name}
      placeholder={label}
      value={value}
      type={type}
      InputProps={{
        style: { color: "var(--txt-color)" },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      {...other}
      {...(error && { error: true, helperText: error })}
      onChange={onChange}
      InputLabelProps={{
        style: { color: "var(--txt-color)" },
      }}
    />
  );
};

export default InputSearch;
